/** API route map: URLS.Controller.ClientGuests */
export const ClientGuests = {
      Name: 'ClientGuest/',
      GetAll: 'guests',
      Add: 'add',
      Update: 'update',
      Delete: 'delete',
      GetGuestSummary: 'get-guest-summary',
      UpdateClientGuest: 'patch-guest',
      UpdateGuestProfileImage: 'update-guest-profile-image',
      ClientSummaryGuests: 'client-summary-guests',
      AddGuestDescription: 'add-guest-description',
      GetAllClientGuests: 'get-all-guests',
};
